"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationCandidate = RegistrationCandidate;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const elements_1 = require("@src/components/elements");
const react_intl_1 = require("react-intl");
const account_context_1 = require("@src/context/account-context");
const react_router_1 = require("react-router");
const RegistrationCandidateForm_1 = require("./RegistrationCandidateForm");
function RegistrationCandidate() {
    const history = (0, react_router_1.useHistory)();
    const user = (0, account_context_1.useAccount)();
    const isUserLoggedIn = Boolean(user);
    react_1.default.useEffect(() => {
        if (isUserLoggedIn) {
            history.pushLocalized('/registracia-prihlaseny-pouzivatel');
        }
    }, [isUserLoggedIn]);
    return ((0, jsx_runtime_1.jsxs)(elements_1.Holder, { marginVertical: true, children: [(0, jsx_runtime_1.jsx)(antd_1.Row, { justify: "center", children: (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: { span: 24 }, lg: { span: 12 }, children: (0, jsx_runtime_1.jsx)(elements_1.Title, { level: 2, type: "secondary", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "registration_candidate.registration" }) }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Row, { justify: "center", children: (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: { span: 24 }, lg: { span: 12 }, children: (0, jsx_runtime_1.jsx)(elements_1.Panel, { children: (0, jsx_runtime_1.jsx)(RegistrationCandidateForm_1.RegistrationCandidateForm, {}) }) }) })] }));
}
